// Deprecated in enveloped format transfer.
export class TransferError extends Error {
  constructor(public readonly requestId: string | undefined, message: string, public readonly cause?: unknown) {
    super(message)
    this.name = 'TransferError'

    Object.setPrototypeOf(this, TransferError.prototype)
  }
}
